import React from "react";
import Header from "../../../Home/Header";
import Footer from "../../../Home/Footer";
import PolygonBlockchainHero from "./PolygonBlockchainHero";
import OPStackDev from "./OPStackDev";
import TheFoundation from "./TheFoundation";
import OptimisticRollup from "./OptimisticRollup";
import ReducedCosts from "./ReducedCosts";

function PolygonBlockchain() {
  return (
    <div>
      <Header />
      <PolygonBlockchainHero />
      <OPStackDev />
      <TheFoundation />
      <OptimisticRollup />
      <ReducedCosts />
      <Footer />
    </div>
  );
}

export default PolygonBlockchain;
